import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../components/Typography';
import './portalTabs.scss';

const PortalTabs = ({ tabs, activeTab, onTabChange }) => (
  <div className="portal-tabs">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        className={`portal-tabs__tab ${activeTab === tab.key ? 'portal-tabs__tab--active' : ''} ${tab.pro ? 'portal-tabs__tab--pro' : ''}`}
        onClick={() => !tab.pro && onTabChange(tab.key)}
        disabled={tab.pro}
      >
        {tab.icon}
        <span className="portal-tabs__label">{tab.label}</span>
        {tab.count !== undefined && (
          <span className="portal-tabs__count">{tab.count}</span>
        )}
        {tab.pro && (
          <span className="portal-tabs__pro-badge">PRO</span>
        )}
      </button>
    ))}
  </div>
);

PortalTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.node,
    count: PropTypes.number,
    pro: PropTypes.bool,
  })).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default PortalTabs;
